export default __webpack_public_path__ + "/dist/images/billing-active.svg";